import {enableProdMode, Injectable} from '@angular/core';
import {Environment} from "./environment";

const ENV_OVERRIDE_KEY = 'chapps_environment';

@Injectable()
export class EnvironmentLoader { // @Todo rename to EnvironmentManager


    constructor(
        private readonly environment: Environment
    ) {
        console.group('Application Environment');
        console.log('Matching environment by hostname', this.matchingHostname, this.environmentName);
    }

    get matchingHostname() {
        return hostnames
            .find(host => location.host.endsWith(host));
    }

    get environmentName() {
        return this.environmentOverride || environmentHosts.get(this.matchingHostname);
    }

    get environmentOverride() {
        const env = localStorage.getItem(ENV_OVERRIDE_KEY);

        const environment = Environments[env];
        console.log('Checking for override', env, environment);

        return env as Environments;
    }

    set environmentOverride(env: Environments) {
        localStorage.setItem(ENV_OVERRIDE_KEY, env);
    }

    async init() {
        console.log('Loading environment from server …');
        const response = await fetch(`/environments/environment.${this.environmentName}.json`);
        const environment = await response.json();
        console.table(environment);
        Object.assign(this.environment, environment);
        this.bootstrap();
        console.groupEnd();
        return environment;
    }

    private bootstrap() {
        if (this.environment.production) {
            console.log('Application in production detected')
            enableProdMode();
        }
    }
}


export enum Environments {
    Production = 'production',
    Testing = 'testing',
    Staging = 'staging',
    Development = 'development',
    Local = 'local',
}

const environmentHosts = new Map<string, Environments>([
    ['.chapps.com', Environments.Production],
    ['-test.chapps.com', Environments.Testing],
    ['-sta.chapps.com', Environments.Staging],
    ['-dev.chapps.com', Environments.Development],
    ['.chapps.local', Environments.Local],
    ['.chapps.test', Environments.Local],
]);

const hostnames = Array.from(environmentHosts.keys()).sort();

export function envLoaderFactory(loader: EnvironmentLoader) {
    return () => loader.init();
}
